import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'

const initialState = {
  // pathname: '',
  record: null,
  comment: '',
  isAppendedBoard: false,
  openConfirmDialog: false,
  confirmType: '',
  confirmParams: undefined,
  deleted: false,
  ready: false,
}

const puzzleViewer = (state = initialState, action) => {
  var comment, newState, newRecord
  switch (action.type) {
    // case types.router.LOCATION_CHANGE:
    //   let params = action.payload.location.pathname.split('/')
    //   let regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => `^${LANGUAGE_SHORT_CODE[key]}$`).join('|')
    //   let pathname
    //   if (null !== params[1].match(`/${regstr}/`)) {
    //     params.splice(1,1)
    //     pathname = params.join('/')
    //   }
    //   else {
    //     pathname = action.payload.location.pathname
    //   }
    //   if (pathname === state.pathname) {
    //     return { ...state, pathname }
    //   }
    //   else {
    //     return {
    //       ...deepCopy(initialState), pathname,
    //     }
    //   }
    case types.puzzleViewer.INITIALIZE:
      return { ...deepCopy(initialState) }
    case types.puzzleViewer.OPEN:
      return { ...state, record: action.record }
    case types.puzzleViewer.CHANGED_TEXT:
      return { ...state, [action.name]: action.text }
    case types.puzzleViewer.CHANGED_CHECKBOX:
      return { ...state, [action.name]: action.checked }
    case types.puzzleViewer.comment.OPEN_BOARD:
      newState = deepCopy(state)
      if (!newState.record.comments[action.index]) {
        return state
      }
      newState.record.comments[action.index].openBoard = true
      return newState
    case types.puzzleViewer.comment.CLOSE_BOARD:
      newState = deepCopy(state)
      if (!newState.record.comments[action.index]) {
        return state
      }
      newState.record.comments[action.index].openBoard = false
      return newState
    case types.puzzleViewer.confirmDialog.OPEN:
      return { ...state, openConfirmDialog: true, confirmType: action.confirmType, confirmParams: action.confirmParams }
    case types.puzzleViewer.confirmDialog.CLOSE:
      return { ...state, openConfirmDialog: false }
    case types.puzzleViewer.REQUEST_SELECT_PUZZLE:
      return { ...state, isFetching: true }
    case types.puzzleViewer.RESPONSE_SELECT_PUZZLE:
      if (
        action.response.result === false ||
        action.response.records.length !== 1
      ) {
        return {
          ...state,
          ready: true,
        }
      }
      newRecord = deepCopy(action.response.records[0])
      newRecord.comments = newRecord.comments.map((comment) => {
        return {
          ...comment,
          openBoard: false,
        }
      })
      return {
        ...state,
        record: newRecord,
        ready: true,
      }
    case types.fetch.puzzle.RESPONSE_SELECTED_GOOD:
    case types.fetch.puzzle.RESPONSE_SELECTED_BAD:
      if (
        action.response.result === false ||
        !state.record ||
        action.response.id !== state.record.id
      ) {
        return state
      }
      return {
        ...state,
        record: {
          ...state.record,
          goodNumber: action.response.goodNumber,
          badNumber: action.response.badNumber,
          isSelectedGood: action.response.isSelectedGood,
          isSelectedBad: action.response.isSelectedBad,
        }
      }
    case types.fetch.puzzle.RESPONSE_ADD_COMMENT:
      if (action.response.result === false) {
        return state
      }
      comment = deepCopy(action.response)
      comment.openBoard = false
      delete comment.result
      return {
        ...state,
        record: {
          ...state.record,
          comments: state.record.comments.concat(comment)
        }
      }
    case types.fetch.puzzle.RESPONSE_DELETE_COMMENT:
      if (action.response.result === false || action.response.id !== state.record.id) {
        return state
      }
      return {
        ...state,
        record: {
          ...state.record,
          comments: state.record.comments.filter((comment) => comment.id !== action.response.commentId)
        }
      }
    case types.fetch.puzzle.RESPONSE_DELETE:
      if (action.response.result === false) {
        return state
      }
      return { ...state, deleted: true }
    default:
      return state
  }
}

export default puzzleViewer


// WEBPACK FOOTER //
// ./src/reducers/Page/Puzzle/PuzzleViewer.js